/* VIDA - UI: acordeones suaves y carruseles con swipe (scroll-snap nativo) */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---- Acordeon: se abre/cierra con transicion de altura via grid-template-rows ---- */
  function initAccordions(scope) {
    (scope || document).querySelectorAll('[data-accordion]:not([data-ready])').forEach(function (acc) {
      acc.setAttribute('data-ready', '');
      var single = acc.getAttribute('data-accordion') !== 'multi';
      acc.addEventListener('click', function (e) {
        var btn = e.target.closest('.v-acc__btn');
        if (!btn || !acc.contains(btn)) return;
        var item = btn.closest('.v-acc__item');
        var open = btn.getAttribute('aria-expanded') !== 'true';
        if (open && single) {
          acc.querySelectorAll('.v-acc__btn[aria-expanded="true"]').forEach(function (b) {
            b.setAttribute('aria-expanded', 'false'); b.closest('.v-acc__item').classList.remove('is-open');
          });
        }
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        item.classList.toggle('is-open', open);
        sync();
      });
      /* El contenido cerrado no recibe foco ni lo lee un lector de pantalla (inert) */
      function sync() {
        acc.querySelectorAll('.v-acc__item').forEach(function (it) {
          var p = it.querySelector('.v-acc__panel'); if (!p) return;
          if (it.classList.contains('is-open')) p.removeAttribute('inert'); else p.setAttribute('inert', '');
        });
      }
      sync();
      /* Flechas / Inicio / Fin mueven entre preguntas */
      acc.addEventListener('keydown', function (e) {
        var btn = e.target.closest('.v-acc__btn'); if (!btn) return;
        var btns = Array.prototype.slice.call(acc.querySelectorAll('.v-acc__btn')), i = btns.indexOf(btn), t = null;
        if (e.key === 'ArrowDown') t = btns[(i + 1) % btns.length];
        else if (e.key === 'ArrowUp') t = btns[(i - 1 + btns.length) % btns.length];
        else if (e.key === 'Home') t = btns[0];
        else if (e.key === 'End') t = btns[btns.length - 1];
        if (t) { e.preventDefault(); t.focus(); }
      });
    });
  }

  /* ---- Carrusel ---- */
  function initCarousels(scope) {
    (scope || document).querySelectorAll('[data-carousel]:not([data-ready])').forEach(function (car) {
      car.setAttribute('data-ready', '');
      var track = car.querySelector('[data-carousel-track]');
      var prev = car.querySelector('[data-carousel-prev]');
      var next = car.querySelector('[data-carousel-next]');
      var dotsWrap = car.querySelector('[data-carousel-dots]');
      var slides = Array.prototype.slice.call(track.children);
      if (!slides.length) return;
      var dots = [];
      var current = 0;

      slides.forEach(function (s, i) {
        if (!dotsWrap) return;
        var d = document.createElement('button');
        d.type = 'button'; d.className = 'v-carousel__dot'; d.setAttribute('aria-label', 'Ir a la diapositiva ' + (i + 1));
        d.addEventListener('click', function () { go(i); });
        dotsWrap.appendChild(d); dots.push(d);
      });

      function slideLeft(i) { return slides[i].offsetLeft - track.offsetLeft; }
      function go(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: slideLeft(i), behavior: reduce.matches ? 'auto' : 'smooth' });
      }
      function sync() {
        var x = track.scrollLeft, best = 0, dist = Infinity;
        slides.forEach(function (s, i) { var d = Math.abs(slideLeft(i) - x); if (d < dist) { dist = d; best = i; } });
        current = best;
        dots.forEach(function (d, i) { d.setAttribute('aria-current', i === current ? 'true' : 'false'); });
        if (prev) prev.disabled = current === 0;
        if (next) next.disabled = x + track.clientWidth >= track.scrollWidth - 4;
      }
      var raf;
      track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
      window.addEventListener('resize', sync);
      if (prev) prev.addEventListener('click', function () { go(current - 1); });
      if (next) next.addEventListener('click', function () { go(current + 1); });
      track.setAttribute('tabindex', '0');
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
      });
      sync();

      var ms = parseInt(car.getAttribute('data-autoplay'), 10);
      if (ms && !reduce.matches) {
        var timer, paused = false;
        function tick() {
          if (paused || document.hidden) return;
          if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) go(0); else go(current + 1);
        }
        function start() { clearInterval(timer); timer = setInterval(tick, ms); }
        car.addEventListener('mouseenter', function () { paused = true; });
        car.addEventListener('mouseleave', function () { paused = false; });
        car.addEventListener('focusin', function () { paused = true; });
        car.addEventListener('focusout', function () { paused = false; });
        start();
      }
    });
  }

  function init(scope) { initAccordions(scope); initCarousels(scope); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.VidaUI = { init: init };
})();
